import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'

export const Wrapper = styled.div`
  min-height: 100%;
  background: #fff;
  color: #373737;
`

export const BannerContainer = styled.div`
  width: 100%;
`

export const BannerWrapper = styled.div`
  width: 100%;
`

type CityPhotoProps = {
  src?: string
}

export const CityPhoto = styled.div<CityPhotoProps>`
  position: relative;
  width: 100%;
  min-height: 360px;
  display: flex;
  align-items: flex-end;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-color: #e7e7e7;
  background-image: ${({ src }) =>
    src
      ? `linear-gradient(180deg, rgba(0,0,0,0.06) 15%, rgba(0,0,0,0.68) 100%), url("${src}")`
      : 'linear-gradient(135deg, #ececec 0%, #d8d8d8 100%)'};

  @media (max-width: 800px) {
    min-height: 238px;
  }

  @media (max-width: 520px) {
    min-height: 218px;
  }
`

export const HeroContent = styled.div`
  width: 100%;
  padding: 42px 48px 34px;
  color: white;
  box-sizing: border-box;

  @media (max-width: 800px) {
    padding: 22px 18px 18px;
  }
`

export const PhotoCredit = styled.a`
  position: absolute;
  right: 16px;
  bottom: 52px;
  z-index: 3;
  padding: 4px 7px;
  border-radius: 7px;
  background: rgba(0, 0, 0, 0.42);
  color: rgba(255, 255, 255, 0.92);
  font-size: 9px;
  line-height: 1.2;
  text-decoration: none;
  backdrop-filter: blur(3px);

  &:hover {
    background: rgba(0, 0, 0, 0.58);
    color: #fff;
  }

  @media (max-width: 800px) {
    bottom: 42px;
  }

  @media (max-width: 520px) {
    right: 10px;
    bottom: 36px;
    font-size: 8px;
  }
`

export const Eyebrow = styled.div`
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 6px;
  opacity: 0.92;
`

export const Title = styled.h2`
  margin: 0;
  font-size: 44px;
  line-height: 1.05;
  font-weight: 700;
  text-shadow: 0 2px 14px rgba(0, 0, 0, 0.25);

  @media (max-width: 800px) {
    font-size: 30px;
  }

  @media (max-width: 520px) {
    font-size: 27px;
  }
`

export const RowContainer = styled.div`
  position: absolute;
  top: 18px;
  right: 18px;
  z-index: 5;
`

export const CloseButton = styled.button`
  width: 42px;
  height: 42px;
  border: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.18);
  cursor: pointer;

  &:hover {
    background: #fff;
    transform: scale(1.03);
  }
`

export const FactsGrid = styled.div`
  width: min(1080px, calc(100% - 48px));
  margin: -34px auto 0;
  position: relative;
  z-index: 4;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: min(680px, calc(100% - 28px));
  }

  @media (max-width: 520px) {
    width: calc(100% - 20px);
    margin-top: -24px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
`

export const FactCard = styled.div`
  min-height: 116px;
  padding: 18px 20px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #eeeeee;
  border-radius: 16px;
  box-shadow: 0 8px 26px rgba(0, 0, 0, 0.09);
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 520px) {
    min-height: 102px;
    padding: 12px 11px;
    border-radius: 13px;
    box-shadow: 0 5px 18px rgba(0, 0, 0, 0.07);
  }
`

export const FactTop = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 7px;

  @media (max-width: 520px) {
    gap: 6px;
    margin-bottom: 5px;
  }
`

export const FactIcon = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;

  @media (max-width: 520px) {
    width: 18px;
    height: 18px;
  }
`

export const FactEmoji = styled.span`
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  line-height: 1;

  @media (max-width: 520px) {
    width: 18px;
    height: 18px;
    font-size: 15px;
  }
`

export const FactLabel = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.045em;
  font-weight: 700;
  color: #777;

  @media (max-width: 520px) {
    font-size: 9px;
    letter-spacing: 0.035em;
  }
`

export const FactValue = styled.div`
  font-size: 20px;
  line-height: 1.2;
  font-weight: 700;
  color: #333;

  @media (max-width: 520px) {
    font-size: 16px;
    line-height: 1.15;
  }
`

export const FactSubvalue = styled.div`
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.35;
  color: #777;

  @media (max-width: 520px) {
    margin-top: 3px;
    font-size: 9px;
    line-height: 1.3;
  }
`

export const BodyContainer = styled.div`
  width: min(1080px, calc(100% - 48px));
  margin: 0 auto;
  padding: 48px 0 36px;
  box-sizing: border-box;

  @media (max-width: 800px) {
    width: calc(100% - 24px);
    padding-top: 28px;
    padding-bottom: 24px;
  }

  @media (max-width: 520px) {
    width: calc(100% - 20px);
    padding-top: 24px;
  }
`

export const Section = styled.section`
  margin: 0 0 42px;

  @media (max-width: 520px) {
    margin-bottom: 28px;
  }
`

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 16px;
`

export const SectionTitle = styled.h3`
  margin: 0;
  font-size: 27px;
  line-height: 1.15;
  font-weight: 700;
  color: #363636;

  @media (max-width: 520px) {
    font-size: 21px;
  }
`

export const SectionHint = styled.div`
  font-size: 13px;
  color: #888;
  margin-top: 5px;
`

export const Description = styled.p`
  width: 100%;
  margin: 0;
  font-size: 17px;
  line-height: 1.72;
  color: #555;
  text-align: left;

  @media (max-width: 520px) {
    font-size: 14px;
    line-height: 1.6;
  }
`

export const ExperienceCard = styled.div`
  min-height: 240px;
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(300px, 0.85fr);
  overflow: hidden;
  border-radius: 18px;
  border: 1px solid #ececec;
  background: #fafafa;
  box-shadow: 0 7px 22px rgba(0, 0, 0, 0.06);

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`

export const ExperienceContent = styled.div`
  padding: 30px 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: 760px) {
    padding: 20px 18px 22px;
    order: 2;
  }

  @media (max-width: 520px) {
    padding: 16px 16px 18px;
  }
`

export const ExperienceText = styled.p`
  margin: 0 0 22px;
  max-width: 560px;
  font-size: 16px;
  line-height: 1.6;
  color: #666;

  @media (max-width: 520px) {
    margin-bottom: 14px;
    font-size: 13px;
  }
`

export const ExperienceButton = styled.button`
  min-height: 42px;
  padding: 0 23px;
  border: 0;
  border-radius: 23px;
  background: #e00000;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition:
    transform 0.2s ease,
    background 0.2s ease;

  &:hover {
    background: #c90000;
    transform: translateY(-1px);
  }
`

export const ExperienceImage = styled.div<CityPhotoProps>`
  min-height: 240px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-color: #ececec;
  background-image: ${({ src }) => {
    const resolvedSrc = src?.includes('background_global.jpg')
      ? '/images/experience-fallback.svg'
      : src

    return resolvedSrc
      ? `url("${resolvedSrc}")`
      : 'linear-gradient(135deg, #ececec, #d7d7d7)'
  }};

  @media (max-width: 760px) {
    min-height: 180px;
    order: 1;
  }

  @media (max-width: 520px) {
    min-height: 150px;
  }
`

export const PartnerWideLink = styled.a`
  width: 100%;
  height: 150px;
  border: 1px solid #ececec;
  border-radius: 14px;
  overflow: hidden;
  display: block;
  background: #f7f7f7;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.045);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  picture,
  img {
    width: 100%;
    height: 100%;
    display: block;
  }

  img {
    object-fit: cover;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 9px 22px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 620px) {
    height: 112px;
    border-radius: 12px;
  }
`

export const PartnerGrid = styled.div`
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 340px));
  justify-content: start;
  gap: 12px;

  @media (max-width: 760px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 620px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`

export const PartnerCardLink = styled.a`
  width: 100%;
  height: 145px;
  border: 1px solid #ececec;
  border-radius: 14px;
  overflow: hidden;
  display: block;
  background: #f7f7f7;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.04);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  picture,
  img {
    width: 100%;
    height: 100%;
    display: block;
  }

  img {
    object-fit: cover;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 9px 21px rgba(0, 0, 0, 0.075);
  }

  @media (max-width: 620px) {
    height: 128px;
    border-radius: 12px;
  }
`

export const SwiperDiv = styled(Swiper)`
  width: 100%;
  padding: 4px 4px 12px;
  box-sizing: border-box;

  .swiper-button-next,
  .swiper-button-prev {
    color: #e60000;
    transform: scale(0.72);
  }
`

export const Slide = styled(SwiperSlide)`
  height: auto;
`

export const RouteCard = styled(Link)`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 16px;
  text-decoration: none;
  color: inherit;
  border: 1px solid #ececec;
  background: white;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.07);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.11);
  }
`

export const RouteImage = styled.div<CityPhotoProps>`
  width: 100%;
  height: 148px;
  background-position: center;
  background-size: cover;
  background-color: #efefef;
  background-image: ${({ src }) =>
    src ? `url("${src}")` : 'linear-gradient(135deg, #ececec, #d7d7d7)'};

  @media (max-width: 520px) {
    height: 112px;
  }
`

export const RouteCardContent = styled.div`
  padding: 14px 15px 16px;

  @media (max-width: 520px) {
    padding: 10px 11px 12px;
  }
`

export const RouteTitle = styled.div`
  font-size: 16px;
  line-height: 1.25;
  font-weight: 700;
  color: #383838;
  min-height: 40px;

  @media (max-width: 520px) {
    min-height: 34px;
    font-size: 13px;
  }
`

export const RouteMeta = styled.div`
  margin-top: 9px;
  font-size: 12px;
  color: #777;
`

export const Author = styled.div`
  margin-top: 5px;
  font-size: 12px;
  color: #555;
`

export const CompactInsight = styled.div`
  margin-top: -18px;
  margin-bottom: 28px;
  padding: 10px 12px;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  color: #777;
  font-size: 12px;
  line-height: 1.5;

  strong {
    color: #555;
    font-weight: 700;
  }

  @media (max-width: 520px) {
    margin-top: -12px;
    margin-bottom: 22px;
    padding: 9px 4px;
    font-size: 11px;
  }
`

export const EmptyState = styled.div`
  padding: 26px;
  border-radius: 14px;
  border: 1px dashed #d2d2d2;
  color: #777;
  text-align: center;
`

export const SwiperFooter = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 18px;

  @media (max-width: 520px) {
    margin-top: 10px;
  }
`

export const RedirectButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 20px;
  border: 1px solid #e00000;
  border-radius: 22px;
  color: #d80000;
  text-decoration: none;
  font-weight: 700;
  font-size: 14px;

  &:hover {
    background: #fff5f5;
  }
`

export const AffiliateSection = styled.section`
  margin-top: 8px;
  padding: 26px 28px 20px;
  border-radius: 18px;
  background: #fafafa;
  border: 1px solid #eeeeee;

  @media (max-width: 520px) {
    padding: 18px 12px 16px;
    border-radius: 16px;
  }
`

export const Tittle = styled.div`
  text-align: center;
  font-size: 24px;
  line-height: 1.25;
  font-weight: 600;
  color: #3b3b3b;
  margin-bottom: 22px;

  span:last-child {
    color: #e00000;
  }

  @media (max-width: 520px) {
    margin-bottom: 16px;
    font-size: 19px;
  }
`

export const ButtonsAffiliate = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 720px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px 6px;
  }
`

export const AffiliateDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7px;
`

export const AffiliateLink = styled.a`
  width: 58px;
  height: 58px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border: 1px solid #ececec;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 7px 16px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 520px) {
    width: 48px;
    height: 48px;
  }
`

export const ButtonIcon = styled.img`
  width: 38px;
  height: 38px;
  object-fit: contain;

  @media (max-width: 520px) {
    width: 31px;
    height: 31px;
  }
`

export const AffiliateTitle = styled.div`
  text-align: center;
  font-size: 12px;
  color: #555;

  @media (max-width: 520px) {
    font-size: 10px;
    line-height: 1.25;
  }
`
